import { render, staticRenderFns } from "./Add_study_modal.vue?vue&type=template&id=cb6212a0"
import script from "./Add_study_modal.vue?vue&type=script&lang=js"
export * from "./Add_study_modal.vue?vue&type=script&lang=js"
import style0 from "./Add_study_modal.vue?vue&type=style&index=0&id=cb6212a0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports